import client from '@/client';
import _ from "lodash";
var context = {
    namespaced: true,
    state: function () {
        return { podcasts: [], context: null };
    },
    getters: {
        selected: function (state) {
            return state.context != null;
        },
        selectable: function (state) {
            return !_.isEmpty(state.podcasts);
        },
        podcasts: function (state) {
            return state.podcasts;
        },
        context: function (state) {
            return state.context;
        }
    },
    mutations: {
        store: function (state, podcasts) {
            state.podcasts = podcasts;
        },
        clear: function (state) {
            state.podcasts = null;
        },
        select: function (state, context) {
            state.context = context;
        },
    },
    actions: {
        setup: function (context) {
            return client.get('/api/account/podcasts')
                .then(function (result) {
                console.log('Podcast data fetched');
                context.commit('store', result.data.data);
                return client.get('/api/account/context');
            })
                .then(function (result) {
                console.log('Podcast context fetched');
                context.commit('select', result.data.data);
                return new Promise(function (r, _) { return r(result.data.data); });
            })
                .then(function (result) {
                console.log('Setting context podcast...');
                context.commit('select', result !== null && result !== void 0 ? result : null);
                return Promise.resolve();
            })
                .catch(function (error) {
                console.log('Setting up podcasts failed');
                context.commit('clear');
                return Promise.reject(error.response.data);
            });
        },
        refresh: function (context, id) {
            return client.get('/api/podcasts/' + id)
                .then(function (result) {
                console.log('Podcast data refreshed');
                context.commit('select', result.data.data);
                return Promise.resolve();
            })
                .catch(function (error) {
                console.log('Refreshing podcast failed');
                context.commit('clear');
                return Promise.reject(error.response.data);
            });
        },
        onboard: function (context, id) {
            return client.get('/api/account/podcasts')
                .then(function (result) {
                console.log('Podcast data fetched');
                context.commit('store', result.data.data);
                return client.get('/api/podcasts/' + id);
            })
                .then(function (result) {
                console.log('Podcast data refreshed');
                context.commit('select', result.data.data);
                return client.post('/api/account/context/' + id);
            })
                .then(function (result) {
                console.log('Podcast context set');
                return Promise.resolve();
            })
                .catch(function (error) {
                console.log('Refreshing podcast failed');
                context.commit('clear');
                return Promise.reject(error.response.data);
            });
        },
        select: function (context, podcast) {
            return client.post('/api/account/context/' + podcast.id)
                .then(function (result) {
                console.log('Podcast context created');
                context.commit('select', podcast);
                return Promise.resolve();
            })
                .catch(function (error) {
                console.log('Selecting context failed');
                context.commit('clear');
                return Promise.reject(error.response.data);
            });
        }
    },
};
export default context;
